import moment, {Moment, MomentInput, unitOfTime} from 'moment';

import {convertRelativeDateToCalendarDateStr, NUMBER_OF_DAYS_IN_UNIT} from 'common/util/date';
import {
  END_OF_TODAY,
  END_OF_YESTERDAY,
  START_OF_TODAY,
  START_OF_YESTERDAY,
} from 'common/widgets/date-range-picker/models/presets';

import {BaseDate, DateRangeAttributes, DateRangeType, RelativeDate, StandardTimeUnit} from './types';

export function getNumberOfDays(dateRange: DateRangeAttributes, asOfDate: Moment): number {
  const fromDate = convertBaseDateToCalendarDate(dateRange.from);
  const toDate = convertBaseDateToCalendarDate(dateRange.to);
  switch (dateRange.type) {
    case DateRangeType.RelativeAfter:
      if (!dateRange.window) {
        throw new Error(`window required for RelativeAfter date ranges.`);
      }
      return Math.ceil(dateRange.window.value * NUMBER_OF_DAYS_IN_UNIT[dateRange.window.unit as StandardTimeUnit]);
    case DateRangeType.Since:
      return asOfDate.diff(fromDate as MomentInput, `days` as unitOfTime.Diff);
    case DateRangeType.On:
      return 1;
    case DateRangeType.Between:
      if (dateRange.from === START_OF_TODAY && dateRange.to === END_OF_TODAY) {
        return 1;
      }
      if (dateRange.from === START_OF_YESTERDAY && dateRange.to === END_OF_YESTERDAY) {
        return 1;
      }
      return moment(toDate as MomentInput).diff(fromDate as MomentInput, `days` as unitOfTime.Diff);
    default:
      throw new Error(`Not implemented for type ${dateRange.type}`);
  }
}

export function convertBaseDateToCalendarDate(baseDate?: BaseDate | null): string | null {
  if (!baseDate) {
    return null;
  }
  if (isRelativeDate(baseDate)) {
    return convertRelativeDateToCalendarDateStr(baseDate);
  }
  return baseDate;
}

export function isRelativeDate(date: BaseDate): date is RelativeDate {
  return Object.prototype.hasOwnProperty.call(date ?? {}, `unit`);
}
